import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Navigation } from 'app/core/navigation/navigation.types';
import { Observable, ReplaySubject, tap } from 'rxjs';
import { BACKEND_URLS, BackendUrls } from 'app/app.config';
import { FuseNavigationItem } from '@fuse/components/navigation';


@Injectable({providedIn: 'root'})
export class NavigationService
{
    private _httpClient = inject(HttpClient);
    private _navigation: ReplaySubject<Navigation> = new ReplaySubject<Navigation>(1);
    private _navMenu: ReplaySubject<FuseNavigationItem[]> = new ReplaySubject<FuseNavigationItem[]>(1);
    private _dataMenu: ReplaySubject<any> = new ReplaySubject<any>(1);
    private backendUrls: BackendUrls = inject(BACKEND_URLS);



    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for navigation
     */
    get navigation$(): Observable<Navigation>
    {
        return this._navigation.asObservable();
    }

    get navMenu$(): Observable<FuseNavigationItem[]>
    {
        return this._navMenu.asObservable();
    }

    get dataMenu$(): Observable<any>
    {
        return this._dataMenu.asObservable();
    }



    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get all navigation data
     */
    get(): Observable<Navigation>
    {
        return this._httpClient.get<Navigation>('api/common/navigation').pipe(
            tap((navigation) =>
            {
                this._navigation.next(navigation);
            }),
        );
    }

    getData(): Observable<any>
    {
        return this._httpClient.get<any>(`${this.backendUrls.backendApiUrl}/utils/plone_menu`).pipe(
            tap((response) =>
            {
                this._dataMenu.next(response);
            }),
        );
    }


    getMenu(): Observable<FuseNavigationItem[]>
    {
        return this._httpClient.get<any>(`${this.backendUrls.backendApiUrl}/utils/plone_menu`).pipe(
            tap((response) =>
            {

                const menu:FuseNavigationItem[] = response.principale;
                menu.push(
                    { type : 'spacer',
                        classes: {
                            wrapper: 'px-20'
                        }
                    });
                this._navMenu.next(menu.concat(response.secondario));
            }),
        );
    }

    getById(id:string): Observable<Navigation>
    {
        return this._httpClient.get<Navigation>(`${this.backendUrls.backendApiUrl}/navigation/${id}`).pipe(
            tap((navigation) =>
            {

                console.log(this.backendUrls)
                this._navigation.next(navigation);

            }),
        );
    }




}
